import { render, staticRenderFns } from "./realNameImport.vue?vue&type=template&id=900d62cc&"
import script from "./realNameImport.vue?vue&type=script&lang=js&"
export * from "./realNameImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports